import React from "react";
import { BadgeGroup } from "./badge-group";
export function LabelBadgeGroup(props) {
    return (React.createElement(BadgeGroup, { ...props, moreButtonProps: {
            fontSize: "sm",
            height: 6,
            px: 2,
            borderRadius: "full",
            color: "text.primary",
            transition: "100ms background",
            bg: "gray.200",
            _hover: {
                bg: "gray.300",
            },
        } }));
}
